import BookingRoleWorkerSource from '@/models/BookingRoleWorkers/BookingRoleWorkerSource';

export default class CreateBookingRoleWorkersRequest {
    bookingRoleId: string;
    workerIds: string[];
    shiftIds: string[];
    source: BookingRoleWorkerSource;
    sendWorkerOfferNotification: boolean;
}